const POS_TERMINAL_DETAILS_SECTIONS = {
    SUBSCRIPTION: 'subscription',
    TERMINAL: 'terminal',
    EVENTS: 'events',
    PAYLUDD: 'payludd'
};

export default POS_TERMINAL_DETAILS_SECTIONS;